import { Button } from 'foundations-components/transitional/components/Button';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  onResetFilters: PropTypes.func.isRequired
};
class TimelineClearFiltersButton extends PureComponent {
  render() {
    return /*#__PURE__*/_jsx(Button, {
      "data-selenium-test": "timeline-clear-filters-button",
      use: "transparent",
      onClick: this.props.onResetFilters,
      responsive: false,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.filters.clearFilters"
      })
    });
  }
}
TimelineClearFiltersButton.propTypes = propTypes;
export default TimelineClearFiltersButton;